module.exports = __webpack_public_path__ + "static/img/infoTit.8c177771.png";